import { render, staticRenderFns } from "./addParts.vue?vue&type=template&id=2535a865&"
import script from "./addParts.vue?vue&type=script&lang=js&"
export * from "./addParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports